__webpack_require__.p = "/drafts-flag/";